import React, { useState } from 'react'
import map from 'lodash/map'
import ClassNames from 'classnames'

import './Dropdown.scss'

function Dropdown({ disabled, selectedItem, items, onChange, className }) {
  const [open, setOpen] = useState(false)

  const componentClassName = ClassNames(
    'h5g-dropdown',
    {
      'h5g-dropdown-collapsed': !open,
      'h5g-dropdown-disabled': disabled
    },
    className
  )

  const componentSelectedItemClassName = ClassNames('h5g-dropdown-selected-item', {
    open: open
  })

  return (
    <div className={componentClassName}>
      <div
        className={componentSelectedItemClassName}
        onClick={() => {
          if (!disabled) {
            setOpen(!open)
          }
        }}
      >
        <div>{selectedItem}</div>
        <div className="h5g-dropdown-arrow" />
      </div>
      <div className="h5g-dropdown-items">
        {map(items, item => (
          <div
            key={item}
            className="h5g-dropdown-item"
            onClick={() => {
              if (item !== selectedItem) {
                onChange(item)
              }
              setOpen(false)
            }}
          >
            {item}
          </div>
        ))}
      </div>
    </div>
  )
}

export default Dropdown
